import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/analytics";
import 'firebase/compat/remote-config';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Dev
// const firebaseConfig = {
//     apiKey: "AIzaSyDy1jF-PitBXMKDceaNqurDTWbfX1-Fpb8",
//     authDomain: "shohug-enterprise-dev.firebaseapp.com",
//     databaseURL: "https://shohug-enterprise-dev-default-rtdb.firebaseio.com",
//     projectId: "shohug-enterprise-dev",
//     storageBucket: "shohug-enterprise-dev.appspot.com",
//     messagingSenderId: "966340246845",
//     appId: "1:966340246845:web:496becbe5e6a0e6eabd954"
//   };

  // Production shohug-enterprise
  // const firebaseConfig = {
  //   apiKey: "AIzaSyAu6U5kPurXnGZJB3Wr81wbz5VJEuf6eIg",
  //   authDomain: "shohug-enterprise.firebaseapp.com",
  //   databaseURL: "https://shohug-enterprise-default-rtdb.firebaseio.com",
  //   projectId: "shohug-enterprise",
  //   storageBucket: "shohug-enterprise.appspot.com",
  //   messagingSenderId: "951639438700",
  //   appId: "1:951639438700:web:4421f6905631e7b4942f49",
  //   measurementId: "G-TKCNS7EBHC"
  // };

  // Production shohug-enterprise-arafat
const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
};
  

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const remoteConfig = firebase.remoteConfig();
firebase.analytics();
remoteConfig.settings = {
  minimumFetchIntervalMillis: 900000, // 1 hour
  fetchTimeoutMillis: 10000
};
// Initialize Firebase Authentication and get a reference to the service
const auth = firebase.auth();
//auth.useEmulator("http://localhost:9099"); // Default port for the Auth emulator
export {auth, firebase, remoteConfig}